import FOOTWEAR from './footwear.svg'
import APPAREL from './apparel.png'
import APPARELPDF from './apparelPdf.png'
import FOOTWEARPDF from './footwear.png'

export const placeholderImages = {FOOTWEAR, APPAREL}

export const placeholderPDFImages = {FOOTWEAR : FOOTWEARPDF, APPAREL: APPARELPDF}



// WEBPACK FOOTER //
// ./src/stores/vlp/store/placeholders/index.ts